__turbopack_context__.v({
  "card": "CardGrid-module-scss-module__awYM2W__card",
  "content": "CardGrid-module-scss-module__awYM2W__content",
  "gradient-overlay": "CardGrid-module-scss-module__awYM2W__gradient-overlay",
  "overlay": "CardGrid-module-scss-module__awYM2W__overlay",
});
